import { shopScene } from '../shopkit.js';

/** 药铺：城里唯一能买到正经药的地方。 */
export const pharmacyDoc = shopScene({
  id: 'pharmacy',
  name: '药铺',
  shop: 'pharmacy',
  owner: '坐堂郎中',
  desc: '一整面墙的小抽屉，空气里是苦香。',
  w: 20, h: 16,
  counters: [{ gx: 7, gy: 3, len: 5, kind: 'pharmacy' }],
  props: [
    { type: 'medicine_cabinet', gx: 3, gy: 5 },
    { type: 'herb_cabinet', gx: 5, gy: 5 },
    { type: 'herb_basket', gx: 4, gy: 11 },
    { type: 'medical_book_pile', gx: 15, gy: 6 },
    { type: 'chest_labeled', gx: 16, gy: 11 },
  ],
  portals: [
    { to: 'yamen_sq', gx: 10, gy: 15, spawn: [22, 22], label: '回衙前广场' },
  ],
});

export default pharmacyDoc;
